import { DonationCategory } from "../Payment/constant";

export const generaldonation = [
"    Donate and Receive the Supreme Blessings of Lord Krishna",
"Lord Krishna guaranteed in Bhagavad Gita 18.68-69:",    
"For one who explains this supreme secret to the devotees, pure devotional service is guaranteed, and at the end, he will come back to Me, Lord Krishna. There is no one in this world more dear to Me (Lord Krishna) than he, nor will there ever be one more dear.",
"    Please help us to distribute the Bhagavad Gita in Prison Houses and also Schools as part of the Value Education Program",    
"    Or you can also distribute Bhagavad Gita to anyone you wish or any place you like."
];

export const options = [
  {
    value: "option1",
    label: "Gita English",
    columns: ["Column 1", "Column 2", "Column 3"],
    data: ["Data 1", "Data 2", "Data 3"],
  },
  {
    value: "option2",
    label: "Gita Hindi",
    columns: ["Column A", "Column B", "Column C"],
    data: ["Data A", "Data B", "Data C"],
  },
  {
    value: "option3",
    label: "Gita Gujarati",
    columns: ["Column A", "Column B", "Column C"],
    data: ["Data A", "Data B", "Data C"],
  },
  {
    value: "option4",
    label: "Gita Marathi",
    columns: ["Column A", "Column B", "Column C"],
    data: ["Data A", "Data B", "Data C"],
  },


  // Add more options here
];

export const option1: DonationCategory[] = [
    {
      title: "Gita English",
      donations: [
        { id: 1, title: "Donate 20 Bhagavad Gita (1 Box)", amount: 6000 },
        { id: 2, title: "Donate 40 Bhagavad Gita (2 Boxes)", amount: 12000 },
        { id: 3, title: "Donate 60 Bhagavad Gita (3 Boxes)", amount: 18000 },
        { id: 4, title: "Donate 100 Bhagavad Gita (5 Boxes)", amount: 30000 },
        { id: 5, title: "Donate 200 Bhagavad Gita (10 Boxes)", amount: 60000 },
        { id: 6, title: "Donate 300 Bhagavad Gita (15 Boxes)", amount: 90000 },
        { id: 7, title: "Donate 400 Bhagavad Gita (20 Boxes)", amount: 120000 },
        { id: 8, title: "Donate 500 Bhagavad Gita (25 Boxes)", amount: 150000 },
        { id: 9, title: "Donate 1000 Bhagavad Gita (50 Boxes)", amount: 300000 },
        { id: 10, title: "Donate 1600 Bhagavad Gita (80 Boxes)", amount: 480000 },
      ],
    },
  ];
  

  export const option2: DonationCategory[] = [
    {
      title: "Gita Hindi",
      donations: [
        { id: 1, title: "Donate 32 Bhagavad Gita (1 Box)", amount: 7360 },
        { id: 2, title: "Donate 64 Bhagavad Gita (2 Boxes)", amount: 14720 },
        { id: 3, title: "Donate 96 Bhagavad Gita (3 Boxes)", amount: 22080 },
        { id: 4, title: "Donate 160 Bhagavad Gita (5 Boxes)", amount: 36800 },
        { id: 5, title: "Donate 320 Bhagavad Gita (10 Boxes)", amount: 73600 },
        { id: 6, title: "Donate 800 Bhagavad Gita (25 Boxes)", amount: 184000 },
        { id: 7, title: "Donate 1600 Bhagavad Gita (50 Boxes)", amount: 368000 },
        { id: 8, title: "Donate 1920 Bhagavad Gita (60 Boxes)", amount: 441600 },
      ],
    },
  ];
  

  export const option3: DonationCategory[] = [
    {
      title: " Gita Gujarati",
      donations: [
        { id: 1, title: "Donate 20 Bhagavad Gita (1 Box)", amount: 5000 },
        { id: 2, title: "Donate 40 Bhagavad Gita (2 Boxes)", amount: 10000 },
        { id: 3, title: "Donate 60 Bhagavad Gita (3 Boxes)", amount: 15000 },
        { id: 4, title: "Donate 100 Bhagavad Gita (5 Boxes)", amount: 25000 },
        { id: 5, title: "Donate 200 Bhagavad Gita (10 Boxes)", amount: 50000 },
        { id: 6, title: "Donate 300 Bhagavad Gita (15 Boxes)", amount: 75000 },
        { id: 7, title: "Donate 500 Bhagavad Gita (25 Boxes)", amount: 125000 },
        { id: 8, title: "Donate 1000 Bhagavad Gita (50 Boxes)", amount: 250000 },
        { id: 9, title: "Donate 1500 Bhagavad Gita (75 Boxes)", amount: 375000 },
        { id: 10, title: "Donate 1800 Bhagavad Gita (90 Boxes)", amount: 450000 },
      ],
    },
  ];
  
      
  export const option4: DonationCategory[] = [
    {
      title: "Gita Marathi ",
      donations: [
        { id: 1, title: "Donate 32 Bhagavad Gita (1 Box)", amount: 6080 },
        { id: 2, title: "Donate 64 Bhagavad Gita (2 Boxes)", amount: 12160 },
        { id: 3, title: "Donate 96 Bhagavad Gita (3 Boxes)", amount: 18240 },
        { id: 4, title: "Donate 160 Bhagavad Gita (5 Boxes)", amount: 30400 },
        { id: 5, title: "Donate 320 Bhagavad Gita (10 Boxes)", amount: 60800 },
        { id: 6, title: "Donate 640 Bhagavad Gita (20 Boxes)", amount: 121600 },
        { id: 7, title: "Donate 800 Bhagavad Gita (25 Boxes)", amount: 152000 },
        { id: 8, title: "Donate 1600 Bhagavad Gita (50 Boxes)", amount: 304000 },
        { id: 9, title: "Donate 2400 Bhagavad Gita (75 Boxes)", amount: 456000 },
      ],
    },
  ];
  
    